import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import blockImage from "../../assets/images/icon_home/block-user.svg";
import { useLocation, useNavigate } from "react-router-dom";
import arrow from "../../assets/images/icon_tab/arrow.svg";
import { useDispatch } from "react-redux";
import { removeUser } from "../../core/feature/user/userSlice";
import { removeBalance } from "../../core/feature/user/balanceSlice";
import { replace } from "lodash";
import { removeToken } from "../../core/feature/token/tokenSlice";
import { removeLastService } from "../../core/feature/lastService/lastServiceSlice";
import { removeCustomApp } from "../../core/feature/company/customAppsSlice";
import { removeIconApp } from "../../core/feature/company/iconAppSlice";
import { logoutIOS } from "../../config/iosBridge";
import { BrowserView, MobileView } from "react-device-detect";


function ComponentInactiveError() {
  const { t } = useTranslation();
  const [blockedName, setBlockedName] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const dispact = useDispatch();

  useEffect(() => {    
    if (location.pathname.split("/")[2] != undefined) {
      setBlockedName(location.pathname.split("/")[2].replaceAll(/%20/g, " "));
    }
    if (location.pathname.split("/")[3] != undefined) {
      setErrorMessage(
        String(location.pathname.split("/")[3]).replaceAll(/%20/g, " ").replace("**", "")
      );
    }
  }, []);

  const logout = async () => {
    dispact(removeUser());
    dispact(removeBalance());
    dispact(removeToken());
    dispact(removeIconApp());
    dispact(removeLastService());
    dispact(removeCustomApp());
    localStorage.removeItem("company");
    // localStorage.removeItem("credential");
    localStorage.removeItem("tags");
    localStorage.removeItem("card");
    localStorage.setItem("auto_login", "0");

    navigate("/login", { replace: true });

    let deviceName = localStorage.getItem("device");
    if (deviceName != null) {
      if (deviceName.includes("android")) {
        // if device is android, call android function
        var element = document.createElement("a") as HTMLElement;
        element.setAttribute("href", "pspmobile://logout");
        try {
          element.click();
        } catch (error) {}
      } else if (deviceName.includes("ios")) {
        // if device is ios, call ios function
        logoutIOS();
      }
    }
  };

  return (
    <>
      <MobileView>
        <div className="min-h-screen h-full flex flex-col justify-between">
          <div>
            <div className="bg-white px-8 pt-8 pb-3  sticky top-0">
              <section className="flex flex-tow items-center z-50">
                <div
                  onClick={() => {
                    // navigate(`/${props.backUrl}`):
                    logout();
                  }}
                  className="flex bg-white rounded-2xl border-1 border-solid border-gray-400  w-12 h-12 justify-center items-center p-2 active:bg-gray-300"
                >
                  <img
                    src={arrow}
                    style={{ width: 6, height: 12 }}
                    className="m-auto"
                  />
                </div>

                <h1 className="font-montserrat font-bold text-base text-black m-auto relative -left-6">
                  {t("HOME.notif")}
                </h1>
              </section>
            </div>
            <div className="  px-4 py-2">
              <img src={blockImage} alt="blockImage" className="" />
              <div className="text-center">
                <h3 className=" font-bold">{t("HOME.notif")}</h3>
                {blockedName != "" && <p>Halo {blockedName},</p>}
                {/* {errorMessage != "" && <p>{errorMessage},</p>} */}
                {
                  errorMessage == "BLOCK_USER" ? 
                  <div>
                    <p>{t("HOME.inactiveAccount")}</p> 
                    <p>{t("HOME.pleaseCall")}</p>
                  </div>
                  :
                  <p>{errorMessage},</p>
                }
                {/* <p>{t("HOME.inactiveAccount")}</p> */}
                {/* <p>{t("HOME.inactiveInstitution")}</p> */}
                {/* <p>{t("HOME.pleaseCall")}</p> */}
                <p>{t("HOME.thanks")}</p>
              </div>
            </div>
          </div>
          <button
            onClick={() => {
              logout();
            }}
            className="bg-psp-btn-red text-white mx-2.5 h-9 mb-2.5 text-sm font-semibold rounded-lg"
          >
            {t("HOME.close")}
          </button>
        </div>
      </MobileView>
      <BrowserView>
        <div className="min-h-screen h-full flex py-8 flex-col justify-between">
          <div>
            <div className="px-4 py-2">
              <div className="w-full flex justify-center">
                <img src={blockImage} alt="blockImage" className="" />
              </div>
              <div className="text-center">
                <h3 className=" font-bold">{t("HOME.notif")}</h3>
                {blockedName != "" && <p>Halo {blockedName},</p>}
                {/* {errorMessage != "" && <p>{errorMessage},</p>} */}
                {
                  errorMessage == "BLOCK_USER" ? 
                  <div>
                    <p>{t("HOME.inactiveAccount")}</p> 
                    <p>{t("HOME.pleaseCall")}</p>
                  </div>
                  :
                  <p>{errorMessage},</p>
                }
                {/* <p>{t("HOME.inactiveAccount")}</p> */}
                {/* <p>{t("HOME.inactiveInstitution")}</p> */}
                {/* <p>{t("HOME.pleaseCall")}</p> */}
                <p>{t("HOME.thanks")}</p>
              </div>
              <div className="w-full flex justify-center">
                <button
                    onClick={() => {
                    logout();
                    }}
                    className=" w-48 bg-psp-btn-red text-white h-9 text-sm font-semibold rounded-lg"
                >
                    {t("HOME.close")}
                </button>
              </div>
            </div>
          </div>
          {/* <button
            onClick={() => {
              logout();
            }}
            className="bg-psp-btn-red text-white mx-2.5 h-9 mb-2.5 text-sm font-semibold rounded-lg"
          >
            Tutup
          </button> */}
        </div>
      </BrowserView>
    </>
  );
}

export default ComponentInactiveError;
